import {Action, createReducer, on} from '@ngrx/store';
import {
  InfluencerSsoCreate,
  InfluencerSsoCreateError,
  InfluencerSsoCreateSuccess,
  InfluencerSsoDelete,
  InfluencerSsoDeleteError,
  InfluencerSsoDeleteSuccess,
  InfluencerSsoList,
  InfluencerSsoListError,
  InfluencerSsoListSuccess,
  InfluencerSsoUpdate,
  InfluencerSsoUpdateError,
  InfluencerSsoUpdateSuccess,
  ResetInfluencerSsoState
} from './influencer-sso.actions';
import {initialInfluencerSsoState} from './influencer-sso.state';

const generateReducer = createReducer(
  initialInfluencerSsoState,
  on(InfluencerSsoList, (state) => ({
    ...state,
    paginatedInfluencerSso: null,
    success: '',
    error: ''
  })),
  on(InfluencerSsoListSuccess, (state, {paginatedInfluencerSso}) => ({
    ...state,
    paginatedInfluencerSso,
    error: ''
  })),
  on(InfluencerSsoListError, (state, {error}) => ({
    ...state,
    paginatedInfluencerSso: null,
    error
  })),
  on(InfluencerSsoCreate, InfluencerSsoUpdate, InfluencerSsoDelete, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(InfluencerSsoCreateSuccess, (state) => ({
    ...state,
    success: 'Influencer SSO setting added successfully'
  })),
  on(InfluencerSsoUpdateSuccess, (state) => ({
    ...state,
    success: 'Influencer SSO setting updated successfully'
  })),
  on(InfluencerSsoDeleteSuccess, (state) => ({
    ...state,
    success: 'Influencer SSO setting deleted successfully'
  })),
  on(
    InfluencerSsoCreateError,
    InfluencerSsoUpdateError,
    InfluencerSsoDeleteError,
    (state, {error}) => ({...state, error})
  ),
  on(ResetInfluencerSsoState, (state, {params}) => ({...state, ...params}))
);

export function influencerSsoReducer(state = initialInfluencerSsoState, action: Action) {
  return generateReducer(state, action);
}
